import { Dispatch } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import { InstructionsEnum } from '../../../../../core/enums/instruction.enums';
import { setSinglePolygonCoords } from '../../../../../app/redux/slices/singlePolygonCoordinatesSlice';
import { setIsAuthorizedToEditState } from '../../../../../app/redux/slices/isAuthorizedToEditSlice';
import { setMarkersInfo } from '../../../../../app/redux/slices/markersInfoSlice';
import { setMultiPolygonsInfo } from '../../../../../app/redux/slices/multiPolygonsInfoSlice';
import { setMultiPolygonEditedID } from '../../../../../app/redux/slices/multiPolygonEditedIDSlice';
import { setIsDrawPolygonActiveState } from '../../../../../app/redux/slices/isDrawPolygonActiveSlice';
import { setIsEditableState } from '../../../../../app/redux/slices/isEditableSlice';
import { setIsEditingMainPolygonState } from '../../../../../app/redux/slices/isEditingMainPolygonSlice';
import { setMarkerCoordinates } from '../../../../../app/redux/slices/markerCoordinatesSlice';
import { setMapCenterCoords } from '../../../../../app/redux/slices/mapCenterCoordinatesSlice';
import { setMapZoomLevel } from '../../../../../app/redux/slices/mapZoomLevelSlice';
// import { setIsMapLockedState } from '../../../../../app/redux/slices/isMapLockedSlice';
import { setDistanceToPolygonInfo } from '../../../../../app/redux/slices/distanceToPolygonInfoSlice';
import { setIsShowBreakpoints } from '../../../../../app/redux/slices/isShowBreakpointsSlice';
import { setClientCodeState } from '../../../../../app/redux/slices/clientCodeSlice';
import { setIsDrawPolylineActiveState } from '../../../../../app/redux/slices/isDrawPolylineActive';
import { setIsHideMapTilesState } from '../../../../../app/redux/slices/isHideMapTilesSlice';
import { setMapIframeIdState } from '../../../../../app/redux/slices/mapIframeIdSlice';
import { setIsCanAccessMapTileLayerState } from '../../../../../app/redux/slices/isCanAccessMapTileLayer';
import { setIsDecreaseZoomControlAmountState } from '../../../../../app/redux/slices/isDecreaseZoomControlAmount';
import { setIsSendAnimationEnd } from '../../../../../app/redux/slices/isSendAnimationEndSlice';
import { setIsBreakpointsButtonActive } from '../../../../../app/redux/slices/isBreakpointsButtonActiveSlice';
import { setIsSlopeServiceActive } from '../../../../../app/redux/slices/isSlopeServiceActive';
import { setMapOptionsState } from '../../../../../app/redux/slices/mapOptionsSlice';
import { setModalBody } from '../../../../../app/redux/slices/modalBodySlice';
import { setIsModalOpen } from '../../../../../app/redux/slices/isModalOpenSlice';
import { setDistanceBetweenGeneratedPoints } from '../../../../../app/redux/slices/distanceBetweenGeneratedPointsSlice';
import { setIsEditingZoomState } from '../../../../../app/redux/slices/isEditingZoomSlice';
import { setDeletedDrawnPolygonIdState } from '../../../../../app/redux/slices/deletedDrawnPolygonIdSlice';
import { setIsEditDrawnPolygons } from '../../../../../app/redux/slices/isEditDrawnPolygonSlice';
import { setEditedDrawnPolygonInfoState } from '../../../../../app/redux/slices/editedDrawnPolygonInfoSlice';
import { setMapTileUrlState } from '../../../../../app/redux/slices/mapTileUrlSlice';
import { currentTileLayerSetter } from '../../../Layers/TilesLayer/functions/currentTileLayerSetter';
import { setIsUsePolygonCluster } from '../../../../../app/redux/slices/isUsePolygonClusterSlice';
import { setActionsButtons } from '../../../../../app/redux/slices/actionsButtonsSlice';
import { setRegionMarkersInfo } from '../../../../../app/redux/slices/regionMarkersInfoSlice';
import { setIsRegionDataLoading } from '../../../../../app/redux/slices/isRegionDataLoadingSlice';
import { setIsShowRegionLayers } from '../../../../../app/redux/slices/isShowRegionLayersSlice';
import { setIsShowDetailsButton } from '../../../../../app/redux/slices/isShowDetailsButtonSlice';
import { setMapDetailsBody } from '../../../../../app/redux/slices/mapDetailsBodySlice';
import {setIsOnMapClick} from "../../../../../app/redux/slices/isOnMapClickSlice";

export const ParentEventListenerHandler = (
    event: MessageEvent<any>,
    dispatch: Dispatch<AnyAction>,
    setIsGetCurrentCenterAndZoom: React.Dispatch<React.SetStateAction<boolean>>,
    setIsGetCurrentBoundingBox: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    const retrievedData = event.data;
    const retrievedType = event.data.type;
    // const queryString = new URLSearchParams(window.location.search);
    // console.log('query string: ', queryString);
    //---------client---------------------------------------------------------------
    if (retrievedType === InstructionsEnum.ClientCode) {
        dispatch(setClientCodeState(retrievedData.clientCode));
    }

    //---------map---------------------------------------------------------------

    //*mapDetailsBody
    if (retrievedType === InstructionsEnum.MapDetailsBody) {
        dispatch(setMapDetailsBody(retrievedData.mapDetailsBody));
    }

    //*isShowRegionLayers
    if (retrievedType === InstructionsEnum.IsShowRegionLayers) {
        dispatch(setIsShowRegionLayers(retrievedData.isShowRegionLayers));
    }

    //*isShowDetailsButton
    if (retrievedType === InstructionsEnum.IsShowDetailsButton) {
        dispatch(setIsShowDetailsButton(retrievedData.isShowDetailsButton));
    }

    //*isOnMapClick
    if (retrievedType === InstructionsEnum.isOnMapClick) {
        dispatch(setIsOnMapClick(retrievedData.isOnMapClick));
    }

    //*isRegionDataLoading
    if (retrievedType === InstructionsEnum.IsRegionDataLoading) {
        dispatch(setIsRegionDataLoading(retrievedData.isRegionDataLoading));
    }
    //*actionsButtons

    if (retrievedType === InstructionsEnum.ActionsButtons) {
        dispatch(setActionsButtons(retrievedData.actionsButtons));
    }

    //*options
    if (retrievedType === InstructionsEnum.MapOptions) {
        dispatch(setMapOptionsState(retrievedData.options));
    }

    //*map custom id
    if (retrievedType === InstructionsEnum.MapIframeCustomId) {
        dispatch(setMapIframeIdState(retrievedData.mapIframeId));
    }

    //*default tile layer
    if (retrievedType === InstructionsEnum.DefaultTileLayer) {
        dispatch(setMapTileUrlState(currentTileLayerSetter(retrievedData.defaultTileLayer)));
    }

    //*map center & zoom
    if (retrievedType === InstructionsEnum.MapAttributes) {
        dispatch(setMapCenterCoords(retrievedData.center));
        dispatch(setMapZoomLevel(retrievedData.zoom));
        // dispatch(setIsMapLockedState(retrievedData.isMapLocked));
    }

    //*send current center & zoom
    if (retrievedType === InstructionsEnum.CurrentCenterAndZoom) {
        setIsGetCurrentCenterAndZoom(retrievedData.getCurrentCenterAndZoom);
    }

    //*send current bounding box
    if (retrievedType === InstructionsEnum.CurrentBoundingBox) {
        setIsGetCurrentBoundingBox(retrievedData.getCurrentMapBoundingBox);
    }

    //*breakpoints button
    if (retrievedType === InstructionsEnum.BreakpointsButtonActivation) {
        dispatch(setIsBreakpointsButtonActive(retrievedData.isBreakpointsButtonActive));
    }

    //*map tile layer display toggle
    if (retrievedType === InstructionsEnum.HideMapTiles) {
        dispatch(setIsHideMapTilesState(retrievedData.isHideMapTiles));
    }

    //*authorize access to current tile layer
    if (retrievedType === InstructionsEnum.MapTileLayerAccess) {
        dispatch(setIsCanAccessMapTileLayerState(retrievedData.isAccessMapTileLayer));
    }

    //*decrease zoom in/out increment
    if (retrievedType === InstructionsEnum.DecreaseZoomControlAmount) {
        dispatch(setIsDecreaseZoomControlAmountState(retrievedData.isDecreaseZoomControlAmount));
    }

    //*animation end
    if (retrievedType === InstructionsEnum.SendAnimationEnd) {
        dispatch(setIsSendAnimationEnd(retrievedData.isSendAnimationEnd));
    }

    //*slope service
    if (event.data.type === InstructionsEnum.SlopeServiceActivation) {
        dispatch(setIsSlopeServiceActive(event.data.isSlopeServiceActive));
    }

    //*editing zoom (for secretariat in sabak)
    if (retrievedType === InstructionsEnum.EditZoom) {
        dispatch(setIsEditingZoomState(retrievedData.isEditingZoom));
    }

    //---------polygons----------------------------------------------------------
    if (retrievedType === InstructionsEnum.SinglePolygon) {
        dispatch(setSinglePolygonCoords(retrievedData.singlePolygonCoords));
        dispatch(setIsAuthorizedToEditState(retrievedData.isAuthorizedToEdit));
        dispatch(setIsEditableState(retrievedData.isEditable));
        dispatch(setIsEditingMainPolygonState(retrievedData.isEditingMainPolygon));
        dispatch(setIsShowBreakpoints(retrievedData.showBreakpoints));
    }
    if (retrievedType === InstructionsEnum.PolygonDrawActivation) {
        dispatch(setIsDrawPolygonActiveState(retrievedData.isDrawPolygonActive));
    }
    if (retrievedType === InstructionsEnum.MultiPolygonsInfo) {
        // console.log('garden poly info in map: ', retrievedData.gardensPolygonsData);
        dispatch(setMultiPolygonsInfo(retrievedData.polygonsData));
    }
    if (retrievedType === InstructionsEnum.MultiPolygonEditedID) {
        dispatch(setMultiPolygonEditedID(retrievedData.editedPolygonID));
    }
    //*drawn polygons
    if (retrievedType === InstructionsEnum.EditDrawnPolygons) {
        dispatch(setIsEditDrawnPolygons(retrievedData.isEditDrawnPolygons));
        dispatch(setIsAuthorizedToEditState(retrievedData.isAuthorizedToEdit));
    }
    if (retrievedType === InstructionsEnum.EditSingleDrawnPolygon) {
        dispatch(setEditedDrawnPolygonInfoState(retrievedData.editedDrawnPolygonData));
    }
    if (retrievedType === InstructionsEnum.DeletedDrawnPolygonID) {
        dispatch(setDeletedDrawnPolygonIdState(retrievedData.deletedDrawnPolygonId));
    }
    if (retrievedType === InstructionsEnum.UsePolygonCluster) {
        dispatch(setIsUsePolygonCluster(retrievedData.isUsePolygonCluster));
    }
    if (retrievedType === InstructionsEnum.MinPolygonClusterDisplayZoom) {
        dispatch(setDeletedDrawnPolygonIdState(retrievedData.minimumPolygonClusterDisplayZoom));
    }
    //---------polyline----------------------------------------------------------
    if (retrievedType === InstructionsEnum.DistanceToPolygonInfo) {
        dispatch(setDistanceToPolygonInfo(retrievedData.distanceToPolygonInfo));
    }
    if (retrievedType === InstructionsEnum.PolylineDrawActivation) {
        dispatch(setIsDrawPolylineActiveState(retrievedData.isDrawingPolyline));
    }
    //---------markers-----------------------------------------------------------
    if (retrievedType === InstructionsEnum.SingleMarker) {
        dispatch(setMarkerCoordinates(retrievedData.marker));
    }
    if (retrievedType === InstructionsEnum.Markers) {
        // console.log('BUILDINGS DATA: ', retrievedData.existingMarkers);
        dispatch(setMarkersInfo(retrievedData.markersData));
    }

    if (retrievedType === InstructionsEnum.RegionMarkers) {
        // console.log('BUILDINGS DATA: ', retrievedData.existingMarkers);
        dispatch(setRegionMarkersInfo(retrievedData.regionMarkersData));
    }

    //---------modal-----------------------------------------------------------
    if (retrievedType === InstructionsEnum.Modal) {
        dispatch(setModalBody(retrievedData.modalBody));
        dispatch(setIsModalOpen(true));
    }
    //---------generate points-----------------------------------------------------------
    if (retrievedType === InstructionsEnum.GeneratePoints) {
        dispatch(setDistanceBetweenGeneratedPoints(retrievedData.distanceBetweenGeneratedPoints));
    }

    // IMPORTANT: check the origin of the data!
    if (event.origin === '*') {
        // The data was sent from your site.
        // Data sent with postMessage is stored in event.data:
        // console.log(event.data);
    } else {
        // The data was NOT sent from your site!
        // Be careful! Do not use it. This else branch is
        // here just for clarity, you usually shouldn't need it.
        return;
    }
};
